import { render, staticRenderFns } from "./ac-dual-list.vue?vue&type=template&id=0f7f1012&scoped=true&"
import script from "./ac-dual-list.vue?vue&type=script&lang=js&"
export * from "./ac-dual-list.vue?vue&type=script&lang=js&"
import style0 from "./ac-dual-list.vue?vue&type=style&index=0&id=0f7f1012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7f1012",
  null
  
)

export default component.exports